import {
    AppIdentifiers,
    AreaType,
    IAppClosedTopicPayload,
    IPaymentActionData,
    ITopicHeaders,
    ITopicSubscription,
    MessageBroker,
    PostLoginActionNameEnum,
    PaymentChannel,
    SessionChannel,
    WalletChannel,
} from '@sparkware/uc-sdk-core';
import Container from 'typedi';
import { StorageItemEnum } from '../../../models/enums/storage-enums';
import { NativeUtils } from '../../native/native.utils';
import { SessionSimpleStoreService } from '../../storage/implementations/simple-store';
import {
    IOpenCashierPostLoginOptions,
    IPostLoginActionsState,
} from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';

const MB_HEADER: ITopicHeaders = { publisher: 'OpenCashierPostLoginAction' };

export class OpenCashierPostLoginAction extends PostLoginActionBase {
    private _appClosedSubscription: ITopicSubscription;
    private readonly _sessionSimpleStoreService: SessionSimpleStoreService;
    private readonly _walletChannel: WalletChannel;
    private readonly _sessionChannel: SessionChannel;
    private readonly _paymentsChannel: PaymentChannel;

    constructor(state: IPostLoginActionsState) {
        super(PostLoginActionNameEnum.OpenCashier, 'OpenCashierPostLoginAction', state);
        this._sessionSimpleStoreService = Container.get(SessionSimpleStoreService);
        this._walletChannel = MessageBroker.getInstance().wallet;
        this._sessionChannel = MessageBroker.getInstance().session;
        this._paymentsChannel = MessageBroker.getInstance().payments;

        this._appClosedSubscription = null;
    }

    protected override canExecute = (options: IOpenCashierPostLoginOptions): Promise<boolean> => {
        const canExecute = options?.enabled || false;

        return Promise.resolve(canExecute);
    };

    protected override doAction = async (
        options: IOpenCashierPostLoginOptions,
    ): Promise<boolean> => {
        await NativeUtils.showBottomBar(false);

        this.clearOptions();

        this._appClosedSubscription = this._sessionChannel.topics.appClosed.subscribe(
            this._onCashierClose,
        );

        const promoCode = options?.promo || undefined;

        const paymentData: IPaymentActionData = {
            OnClose: this._onCashierClose,
            PromoCode: promoCode,
            Area: options?.channel?.Area as AreaType,
            Source: options?.channel?.Source,
            Element: options?.channel?.Element,
        };

        this._paymentsChannel.topics.CTA_Cashier_Open.publish(MB_HEADER, paymentData);
        return false;
    };

    private _isCashierApp = (appID: AppIdentifiers) =>
        [AppIdentifiers.FullCashier, AppIdentifiers.UnifiedCashier].some((id) => id === appID);

    private _onCashierClose = (data: IAppClosedTopicPayload) => {
        if (!data?.appID || this._isCashierApp((data as IAppClosedTopicPayload).appID)) {
            this.completeAction();

            if (!!this._appClosedSubscription) {
                this._appClosedSubscription.unsubscribe();
                this._appClosedSubscription = null;
            }

            const balancePolling =
                this._sessionSimpleStoreService.get(StorageItemEnum.BalancePollingRequired) ===
                'true';

            if (balancePolling) {
                this._walletChannel.topics.UpdateBalance.publish(MB_HEADER, {});
            }
        }
    };
}
